(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dovelka-product-accordion"] && !Shopify.designMode) return;
  try {
    class DovelkaSizeChart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.dovelka-size-chart__toggle');
      this.button?.addEventListener('click', this.toggleUnit);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggleUnit);
    }

    toggleUnit = () => {
      const nextUnit = this.dataset.unit === 'in' ? 'cm' : 'in';
      this.dataset.unit = nextUnit;
      this.button?.setAttribute('aria-checked', String(nextUnit === 'cm'));
      this.querySelectorAll('[data-size-unit]').forEach((value) => {
        value.hidden = value.dataset.sizeUnit !== nextUnit;
      });
    };
  }

  if (!customElements.get('dovelka-size-chart')) {
    customElements.define('dovelka-size-chart', DovelkaSizeChart);
  }
  } catch(e) { console.error(e); }
})();

})();
